module.exports = {
    /**
     *  检验当前浏览器内核
     */
    os: function() {
        var ua = navigator.userAgent,
        isWindowsPhone = /(?:Windows Phone)/.test(ua),
        isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone, 
        isAndroid = /(?:Android)/.test(ua), 
        isFireFox = /(?:Firefox)/.test(ua), 
        isChrome = /(?:Chrome|CriOS)/.test(ua),
        isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
        isPhone = /(?:iPhone)/.test(ua) && !isTablet,
        isPc = !isPhone && !isAndroid && !isSymbian;
        return {
            isTablet: isTablet,
            isPhone: isPhone,
            isAndroid : isAndroid,
            isPc : isPc
        };
    }(),

    app: function() {
        var browser = navigator.userAgent.toLowerCase();
	 
        if(browser.match(/Alipay/i)=="alipay"){
            return 'alipay'
        }else if(browser.match(/MicroMessenger/i)=="micromessenger"){
            return 'wechat'
        }else{
            return 'other'
        }
    }(),
}


// WEBPACK FOOTER //
// ./src/utils.js